import { Body2 } from '../../../../atoms/Typography'
import { Box, HStack, Link } from '../../../../atoms/Layout'
import { BiOutlineLockClosed } from '../../../../atoms/Icons'
import { useDonationFormContext } from '../../DonationFormProvider'
import { ReactNode } from 'react'
import { usePurchaseCopy } from '../../purchaseCopy'

type TermsAndConditionsProps = { legalUrl: string | undefined }

const MARKDOWN_LINK_REGEX = /\[([^\]]+)\]\(([^)]+)\)/g

const parseMarkdownLinks = (text: string): ReactNode[] => {
  const parts: ReactNode[] = []
  let lastIndex = 0
  let match: RegExpExecArray | null

  while ((match = MARKDOWN_LINK_REGEX.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index))
    }
    parts.push(
      <a
        key={match.index}
        href={match[2]}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
        style={{ textDecoration: 'underline', pointerEvents: 'auto' }}
      >
        {match[1]}
      </a>,
    )
    lastIndex = match.index + match[0].length
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex))
  }

  return parts
}

const renderLabel = (label: string | ReactNode): ReactNode => {
  if (typeof label === 'string') {
    return <>{parseMarkdownLinks(label)}</>
  }
  return label
}

const TermsAndConditions = ({ legalUrl }: TermsAndConditionsProps) => {
  const settings = useDonationFormContext((state) => state.settings)
  const purchaseCopy = usePurchaseCopy()
  const customPrivacyStatement = settings?.styles?.legalText

  const renderPrivacyStatement = () => {
    if (customPrivacyStatement && MARKDOWN_LINK_REGEX.test(customPrivacyStatement)) {
      MARKDOWN_LINK_REGEX.lastIndex = 0 // Reset regex state
      return renderLabel(customPrivacyStatement)
    }

    if (!legalUrl) {
      return null
    }

    if (customPrivacyStatement) {
      return (
        <Link color="ge.blue" href={legalUrl} display="inline">
          {customPrivacyStatement}
        </Link>
      )
    }

    return (
      <>
        See our
        <br />
        <Link color="ge.blue" href={legalUrl}>
          privacy collection statement
        </Link>{' '}
        for more info.
      </>
    )
  }
  return (
    <HStack gap="12px" w="100%" justifyContent="center">
      <Box>
        <BiOutlineLockClosed h="25px" w="25px" color="inherit" />
      </Box>
      <Box>
        <Body2>{purchaseCopy('Your donation is secure and protected.')} {renderPrivacyStatement()}</Body2>
      </Box>
    </HStack>
  )
}

export default TermsAndConditions
